import { render, staticRenderFns } from "./BMentionable.vue?vue&type=template&id=8bffcf8a"
import script from "./BMentionable.vue?vue&type=script&lang=js"
export * from "./BMentionable.vue?vue&type=script&lang=js"
import style0 from "./BMentionable.vue?vue&type=style&index=0&id=8bffcf8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports